// "02 / 03" step counters. Wrapped in LRI…PDI so RTL pages don't reorder them to "03 / 02".
export const stepOf = (n: number, total: number) =>
  `⁦${String(n).padStart(2, '0')} / ${String(total).padStart(2, '0')}⁩`;
